<script lang="ts">
    import {FukushimaMinpoService} from "../logics/fukushimaminpo_login_service.js";

    let fukushimaMinpoService = new FukushimaMinpoService();

    async function logout() {
        let result = await fukushimaMinpoService.logout();
        if (!result) {
            errorMessage = "ログアウトに失敗しました。";
        }
    }

    let errorMessage = "";
</script>

<html>
<head>
    <title>My App</title>
    <style>
        /* スタイルをここに記述 */
        body {
            font-family: Arial, sans-serif;
            background-color: #f2f2f2;
            margin: 0;
            padding: 0;
        }

        #header {
            background-color: #333;
            color: #fff;
            padding: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        #header h1 {
            margin: 0;
            font-size: 28px;
        }

        .logout {
            background-color: #fff;
            color: #333;
            border: none;
            border-radius: 5px;
            padding: 10px 20px;
            font-size: 16px;
            cursor: pointer;
            margin-right: 20px;
        }

        #logout:hover {
            background-color: #333;
            color: #fff;
        }

        .launch-app {
            background-color: #333;
            color: #fff;
            border: none;
            border-radius: 5px;
            padding: 10px 20px;
            font-size: 16px;
            cursor: pointer;
        }

        #launch-app:hover {
            background-color: #fff;
            color: #333;
        }

        #content {
            padding: 20px;
        }

        /* レスポンシブデザイン */
        @media screen and (max-width: 600px) {
            #header {
                flex-direction: column;
                text-align: center;
            }

            #header h1 {
                margin-bottom: 10px;
            }

            #logout {
                margin: 10px 0;
                margin-right: 0;
            }
        }

        .center {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
        }

        .card {
            background-color: #f1f1f1;
            border-radius: 10px;
            padding: 20px;
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
            max-width: 400px;
            text-align: center;
        }
    </style>
</head>

<div id="header">
    <h1>福島民報 オンライン新聞</h1>
    <div>
        <button class="logout" on:click={() => logout()}>ログアウト</button>
    </div>
</div>
<div class="center">
    <div class="card">
<!--        <h2>すでにログインされています</h2>-->
        <p>ログアウトするには
            <button class="logout" on:click={() => logout()}>こちら</button>
            をクリックしてください。
        </p>
<!--        <p>-->
<!--            <button class="launch-app" on:click={() => fukushimaMinpoService.redirectToApp()}> アプリを起動</button>-->
<!--        </p>-->
        <div style="color:red;">
            <p>{errorMessage}</p>
        </div>

    </div>
</div>
</html>

